// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReturnHeader_wrapper__1aCeh","right-text":"ReturnHeader_right-text__2HKlZ","return-link":"ReturnHeader_return-link__1KpLG"};